var exports = {
  "kL": "InboxPopout.module__container___UHNkdV",
  "rf": "InboxPopout.module__body___UHNkdV",
  "pz": "InboxPopout.module__sidebar___UHNkdV",
  "G9": "InboxPopout.module__sidebarTabList___UHNkdV",
  "NP": "InboxPopout.module__sidebarFooterActions___UHNkdV",
  "jR": "InboxPopout.module__sidebarActionButton___UHNkdV",
  "M6": "InboxPopout.module__mainPanel___UHNkdV",
  "yt": "InboxPopout.module__sidebarTab___UHNkdV",
  "yR": "InboxPopout.module__tabActive___UHNkdV",
  "DF": "InboxPopout.module__tabInactive___UHNkdV",
  "Qs": "InboxPopout.module__content___UHNkdV",
  "Lj": "InboxPopout.module__tabContent___UHNkdV",
  "Bx": "InboxPopout.module__iconSmall___UHNkdV",
};

module.exports = exports;
